import { listInstanceRegistry } from 'src/util/listInstance/listInstanceRegistry';

export type ListInstanceFetcher = (context: {
	listStore: unknown;
	params: Record<string, unknown>;
	queryStore: unknown;
	runtimeStore: unknown;
}) => void;

const fetchers = new Map<string, ListInstanceFetcher>();

export const registerListInstanceFetcher = (moduleRouteName: string, fetcher: ListInstanceFetcher): void => {
	fetchers.set(moduleRouteName, fetcher);
};

export const getListInstanceFetcher = (moduleRouteName: string): ListInstanceFetcher | undefined =>
	fetchers.get(moduleRouteName);

export type ListInstanceResolution =
	| { listStore: null; outcome: 'default'; queryStore: null }
	| { listStore: null; outcome: 'missing'; queryStore: null }
	| { listStore: unknown; outcome: 'instance'; queryStore: unknown };

// MUST-FIX F: drei-wertig. 'missing' (Instanz-Key ohne Registry-Eintrag = verspäteter
// Fetch aus geschlossenem Tab) DARF NIE auf den Default zurückfallen.
export const resolveListInstance = (genericListIdentifier: string | undefined): ListInstanceResolution => {
	if (genericListIdentifier === undefined || !genericListIdentifier.includes('#')) {
		return { listStore: null, outcome: 'default', queryStore: null };
	}
	const handle = listInstanceRegistry.get(genericListIdentifier);
	if (handle === null) {
		return { listStore: null, outcome: 'missing', queryStore: null };
	}
	return { listStore: handle.storeInstance, outcome: 'instance', queryStore: handle.queryStore };
};
